module.exports = __webpack_public_path__ + "static/media/home_personal_folder.3947fc42.png";